import React, { Component } from 'react';
import { withStyles } from '@mui/styles';

const styles = theme => ({});

class UserAdd extends Component {

    render() {
        return (
            <div style={{ width: "100%", height: "82vh" }}>Test</div>
        );
    }
}

export default withStyles(styles)(UserAdd);



// WEBPACK FOOTER //
// ./src/components/user-add/index.js